import React from "react";
import { Box, Container, Typography, Grid } from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";

const Footer = () => {
    return (
        <Box sx={{ bgcolor: "#121212", color: "white", py: 5, mt: 5 }}>
            <Container maxWidth="lg">
                <Grid container spacing={4}>
                    {/* Sol Kısım - Şirket Bilgisi */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" fontWeight="bold">
                            <Box component="span" sx={{ backgroundColor: "white", color: "black", px: 1, fontWeight: "bold" }}>M</Box> Silivri Muhasebe, Mali Müşavirlik ve Danışmanlık Hizmetleri
                        </Typography>
                        <Typography variant="body2" sx={{ mt: 2, color: "#bdbdbd" }}>
                            Serbest Muhasebe ve Mali Müşavirlik ofisimiz, ilk günden itibaren müşteri memnuniyeti odaklı hizmetlerine devam ediyor.
                        </Typography>
                    </Grid>

                    {/* Orta Kısım - İletişim Bilgileri */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" fontWeight="bold">Bize Ulaşın</Typography>
                        <Box sx={{ display: "flex", alignItems: "center", mt: 2, color: "#bdbdbd" }}>
                            <LocationOnIcon fontSize="small" sx={{ mr: 1 }} />
                            <Typography variant="body2">Alibey Mah. Başkomutan Cad. Özel İdare İş Merkezi K:5 D:53, Silivri - İstanbul</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", mt: 1, color: "#bdbdbd" }}>
                            <PhoneIcon fontSize="small" sx={{ mr: 1 }} />
                            <Typography variant="body2">0552 167 36 34</Typography>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", mt: 1, color: "#bdbdbd" }}>
                            <EmailIcon fontSize="small" sx={{ mr: 1 }} />
                            <Typography variant="body2">gulden.cetinkayakopan@ismmmo.org.tr</Typography>
                        </Box>
                    </Grid>

                    {/* Sağ Kısım - Hizmetler */}
                    <Grid item xs={12} md={4}>
                        <Typography variant="h6" fontWeight="bold">Hizmetlerimiz</Typography>
                        <Box sx={{ mt: 2 }}>
                            <Typography variant="body2" sx={{ color: "#bdbdbd" }}>• Şirket Kuruluş Hizmetleri</Typography>
                            <Typography variant="body2" sx={{ color: "#bdbdbd" }}>• Muhasebe ve Mali Müşavirlik Hizmetleri</Typography>
                            <Typography variant="body2" sx={{ color: "#bdbdbd" }}>• Mali Danışmanlık Hizmetleri</Typography>
                            <Typography variant="body2" sx={{ color: "#bdbdbd" }}>• Bordrolama ve Personel Hizmetleri</Typography>
                            <Typography variant="body2" sx={{ color: "#bdbdbd" }}>• Yönetim ve Denetim Hizmetleri</Typography>
                            <Typography variant="body2" sx={{ color: "#bdbdbd" }}>• Yapılandırma, Teşvik ve Hibe Danışmanlığı</Typography>
                            <Typography variant="body2" sx={{ color: "#bdbdbd" }}>• E‑Ticaret Satış Muhasebesi</Typography>
                        </Box>
                    </Grid>
                </Grid>

                {/* Copyright & Yukarı Çık Butonu */}
                <Box sx={{ textAlign: "center", mt: 5, borderTop: "1px solid #333", pt: 3 }}>
                    <Typography variant="body2" sx={{ color: "#bdbdbd" }}>
                        Web sitemizdeki bilgi ve açıklamalar yalnızca bilgilendirme amaçlı olup TÜRMOB’nin ilgili mevzuatına uygun olarak hazırlanmıştır. Sitede yapılan bütün açıklamalar bilgilendirme amaçlıdır ve bu bilgiler iş geliştirmeye yönelik olarak kullanılamaz.
                    </Typography>
                </Box>
            </Container>
        </Box>
    );
};

export default Footer;
